import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Store } from '../../redux/Store';
import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { Elements, StripeProvider } from 'react-stripe-elements';
import './Contact.css';


class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked--order']
        }
    }

    componentWillMount() {
        document.body.classList.add(...this.state.body_class);
    }

    render() {
        return (
            <div>
                <div className="apps-gotlocked--video-bg-section"></div>
                <section className="apps-gotlocked--order-section" id="apps-gotlocked--questions">
                    <div className="apps-gotlocked--order-container">
                        <div className="container">
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-order-tbl-c">
                                        <div className="apps-gotlocked-order-content text-center">
                                            <h1>GotLocked Contact</h1>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-contact-form-content wow fadeIn" data-wow-delay="800ms">
                                        <div className="apps-gotlocked-contact-form-content-inner">
                                            <h2>Any Other question? You can <span>Contact Us.</span></h2>
                                            <div className="apps-gotlocked-contact-form">
                                                <form action="#" method="POST" id="apps-gotlocked-form">
                                                    <input type="email" id="apps-gotlocked-input-email" name="email" placeholder="12345@domain.com" />
                                                    <textarea name="massage" id="apps-gotlocked-input-message" cols="30" rows="10" placeholder="Your Message Here.."></textarea>

                                                    <div className="apps-gotlocked-submit-btn-ar">
                                                        <input type="submit" name="Send Message" value="Send Message" id="apps-gotlocked-input-send" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </section>
            </div >
        );
    }
}


export default Contact;